

import React from 'react'
import { LoadingComponent } from './LoadingComponent'

const TableLoading = () => {
    return (
        <tr style={{ borderColor: "transparent" }}>
            <td colSpan={20}>
                <LoadingComponent />
            </td>
        </tr>
    )
}

export default TableLoading
